import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { GlobalMenuGroupsRouteNames, GlobalMenuGroupsRoutePathNames } from '../../enums';
import { useAuthStore } from '@centric-os/stores/auth/use-auth-store';
import { MenuScopeActions, MenuScopeServices } from '@centric-os/types';

const Component = () => import('./GlobalMenuGroupList.vue');

export default {
  path: buildChildURL(GlobalMenuGroupsRoutePathNames.LIST),
  name: GlobalMenuGroupsRouteNames.GLOBAL_MENU_GROUPS_LIST,
  component: Component,
  beforeEnter: () => {
    const authStore = useAuthStore();

    const scopesIds = authStore.getScopeIds(
      MenuScopeActions.READ,
      MenuScopeServices.GLOBAL_MENU_GROUP,
    );
    const shouldRedirect = scopesIds?.length === 1 && scopesIds?.[0] !== '*';
    if (shouldRedirect) {
      const id = scopesIds[0];
      return {
        name: GlobalMenuGroupsRouteNames.GLOBAL_MENU_GROUPS_DETAILS,
        params: { id },
        replace: true,
      };
    }
    return true;
  },
} as RouteRecordRaw;
